// Local Server
// export const API_URL = 'http://localhost:8085'
// EI Server
// export const API_URL = 'http://1.186.69.29:8085'
// Server
export const API_URL = 'https://ekathvainnovations.com/services'
